/* eslint-disable-next-line */
import classNames from 'classnames';

export interface LoadingSpinnerProps {
  makeAbsolute?: boolean;
  spinnerId?: string;
}

export function LoadingSpinner({
  makeAbsolute,
  spinnerId,
}: LoadingSpinnerProps) {
  return (
    <div
      data-spinner-id={spinnerId}
      className={classNames(
        'top-0 left-0 w-[100vw] h-[100vh] flex justify-center items-center pointer-events-none',
        { absolute: makeAbsolute, fixed: !makeAbsolute }
      )}
    >
      <i className="fa-solid fa-spinner-third animate-spin text-6xl text-light-primaryText dark:text-dark-primaryText" />
    </div>
  );
}

export default LoadingSpinner;
